import { NotifyPropertyChangedBase } from "../../../../utilities/reflection";
import { autoinject, bindable } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { Query, type QueryAssignmentBulkItem, AssignmentItem, type QueryCategoryLookupsModel } from "../../../../models/queries/queries.models";
import { GenericConfirmationDialogModel } from "../../../../models/basics/generic-confirmation-dialog-model";
import { I18N } from "aurelia-i18n";

@autoinject
export class ManageQueryAssignments extends NotifyPropertyChangedBase {

    @bindable
    public query: Query;

    @bindable
    public savedAssignments: QueryAssignmentBulkItem;

    @bindable
    public unsavedAssignments: QueryAssignmentBulkItem;

    @bindable
    public deletedAssignments: QueryAssignmentBulkItem;

    @bindable
    public lookupViewModels: QueryCategoryLookupsModel = { unsavedBranchesLookupVMs: [], unsavedDepartmentsLookupVMs: [], unsavedRolesLookupVMs: [], unsavedUsersLookupVMs: [] };

    constructor(private dialogClient: DialogClientService, private i18N: I18N) {
        super();
    }

    addBranch() {
        this.unsavedAssignments.branchQueryAssignments.push({ id: null, isDefault: false });
    }

    addDepartment() {
        this.unsavedAssignments.departmentQueryAssignments.push({ id: null, isDefault: false });
    }

    addRole() {
        this.unsavedAssignments.roleQueryAssignments.push({ id: null, isDefault: false });
    }

    addUser() {
        this.unsavedAssignments.userQueryAssignments.push({ id: null, isDefault: false });
    }

    deleteBranch(branch: AssignmentItem) {
        if (this.savedAssignments.branchQueryAssignments.findIndex(x => x == branch) != -1) {
            const model = new GenericConfirmationDialogModel();
            model.confirm = this.i18N.tr('delete-text');
            model.cancel = this.i18N.tr('cancel');
            model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delet'));
            model.title = this.i18N.tr('confirm-delete-text');
            model.onConfirm = () => {
                this.savedAssignments.branchQueryAssignments = this.savedAssignments.branchQueryAssignments.filter(x => x != branch);
                this.deletedAssignments.branchQueryAssignments.push({ id: branch.id, isDefault: false });
            };
            this.dialogClient.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model, false, false);
        }
        else if (this.unsavedAssignments.branchQueryAssignments.findIndex(x => x == branch) != -1) {
            this.unsavedAssignments.branchQueryAssignments = this.unsavedAssignments.branchQueryAssignments.filter(x => x != branch);
        }
    }

    deleteDepartment(department: AssignmentItem) {
        if (this.savedAssignments.departmentQueryAssignments.findIndex(x => x == department) != -1) {
            const model = new GenericConfirmationDialogModel();
            model.confirm = this.i18N.tr('delete-text');
            model.cancel = this.i18N.tr('cancel');
            model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delet'));
            model.title = this.i18N.tr('confirm-delete-text');
            model.onConfirm = () => {
                this.savedAssignments.departmentQueryAssignments = this.savedAssignments.departmentQueryAssignments.filter(x => x != department);
                this.deletedAssignments.departmentQueryAssignments.push({ id: department.id, isDefault: false });
            };
            this.dialogClient.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model, false, false);
        }
        else if (this.unsavedAssignments.departmentQueryAssignments.findIndex(x => x == department) != -1) {
            this.unsavedAssignments.departmentQueryAssignments = this.unsavedAssignments.departmentQueryAssignments.filter(x => x != department);
        }
    }

    deleteUser(user: AssignmentItem) {
        if (this.savedAssignments.userQueryAssignments.findIndex(x => x == user) != -1) {
            const model = new GenericConfirmationDialogModel();
            model.confirm = this.i18N.tr('delete-text');
            model.cancel = this.i18N.tr('cancel');
            model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delet'));
            model.title = this.i18N.tr('confirm-delete-text');
            model.onConfirm = () => {
                this.savedAssignments.userQueryAssignments = this.savedAssignments.userQueryAssignments.filter(x => x != user);
                this.deletedAssignments.userQueryAssignments.push({ id: user.id, isDefault: false });
            };
            this.dialogClient.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model, false, false);
        }
        else if (this.unsavedAssignments.userQueryAssignments.findIndex(x => x == user) != -1) {
            this.unsavedAssignments.userQueryAssignments = this.unsavedAssignments.userQueryAssignments.filter(x => x != user);
        }
    }

    deleteRole(role: AssignmentItem) {
        if (this.savedAssignments.roleQueryAssignments.findIndex(x => x == role) != -1) {
            const model = new GenericConfirmationDialogModel();
            model.confirm = this.i18N.tr('delete-text');
            model.cancel = this.i18N.tr('cancel');
            model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delet'));
            model.title = this.i18N.tr('confirm-delete-text');
            model.onConfirm = () => {
                this.savedAssignments.roleQueryAssignments = this.savedAssignments.roleQueryAssignments.filter(x => x != role);
                this.deletedAssignments.roleQueryAssignments.push({ id: role.id, isDefault: false });
            };
            this.dialogClient.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model, false, false);
        }
        else if (this.unsavedAssignments.roleQueryAssignments.findIndex(x => x == role) != -1) {
            this.unsavedAssignments.roleQueryAssignments = this.unsavedAssignments.roleQueryAssignments.filter(x => x != role);
        }
    }
}